import * as v from 'valibot';

// Video bitrates schema
const MaxBitratesVideoSchema = v.object({
  low: v.optional(v.number()),
  standard: v.optional(v.number()),
  high: v.optional(v.number()),
  fullHd: v.optional(v.number()),
  ultraHd: v.optional(v.number()),
  ssHigh: v.optional(v.number()),
});

// Codec config schema
const CodecConfigSchema = v.object({
  maxBitratesVideo: v.optional(MaxBitratesVideoSchema),
  scalabilityModeEnabled: v.optional(v.boolean()),
  useSimulcast: v.optional(v.boolean()),
  useKSVC: v.optional(v.boolean()),
});

// Video quality schema
const VideoQualitySchema = v.object({
  codecPreferenceOrder: v.optional(v.array(v.string())),
  screenshareCodec: v.optional(v.string()),
  mobileScreenshareCodec: v.optional(v.string()),
  enableAdaptiveMode: v.optional(v.boolean()),
  av1: v.optional(CodecConfigSchema),
  h264: v.optional(CodecConfigSchema),
  vp8: v.optional(CodecConfigSchema),
  vp9: v.optional(CodecConfigSchema),
  minHeightForQualityLvl: v.optional(v.record(v.string(), v.string())),
  mobileCodecPreferenceOrder: v.optional(v.array(v.string())),
});

// User schema
const UserSchema = v.object({
  uid: v.string(),
  name: v.string(),
  avatar: v.optional(v.string()),
  status: v.optional(v.string()),
  role: v.optional(v.string()),
  lastActiveAt: v.optional(v.number()),
});

// Settings schema
const SettingsSchema = v.object({
  WEBRTC_HOST: v.optional(v.string()),
  ANALYTICS_HOST: v.optional(v.string()),
  ANALYTICS_VERSION: v.optional(v.string()),
  PRESENTER_MODE_ENABLED: v.optional(v.boolean()),
  connectionConfig: v.object({
    audioQuality: v.optional(
      v.object({
        stereo: v.optional(v.boolean()),
      }),
    ),

    bridgeChannel: v.optional(
      v.object({
        preferSctp: v.optional(v.boolean()),
      }),
    ),
    constraints: v.optional(
      v.object({
        video: v.optional(
          v.object({
            height: v.optional(
              v.object({
                ideal: v.optional(v.number()),
                max: v.optional(v.number()),
                min: v.optional(v.number()),
              }),
            ),
            width: v.optional(
              v.object({
                ideal: v.optional(v.number()),
                max: v.optional(v.number()),
                min: v.optional(v.number()),
              }),
            ),
          }),
        ),
      }),
    ),
    e2ee: v.optional(v.array(v.unknown())),
    e2eping: v.optional(
      v.object({
        enabled: v.optional(v.boolean()),
      }),
    ),
    flags: v.optional(
      v.object({
        receiveMultipleVideoStreams: v.optional(v.boolean()),
        sendMultipleVideoStreams: v.optional(v.boolean()),
        sourceNameSignaling: v.optional(v.boolean()),
        ssrcRewritingEnabled: v.optional(v.boolean()),
      }),
    ),
    hosts: v.object({
      domain: v.optional(v.string()),
      muc: v.optional(v.string()),
    }),
    hiddenDomain: v.optional(v.string()),
    bosh: v.optional(v.string()),
    websocket: v.optional(v.string()),
    serviceUrl: v.string(),
    p2p: v.object({
      enabled: v.boolean(),
    }),
    resolution: v.optional(v.number()),
    videoQuality: v.optional(VideoQualitySchema),
  }),
});

// Root schema
export const InternalSettingSchema = v.object({
  callToken: v.string(),
  settings: SettingsSchema,
  sessionId: v.string(),
  user: UserSchema,
});

// Inferred TypeScript type
export type InternalSetting = v.InferOutput<typeof InternalSettingSchema>;
